<template>
    <div>
        <div class="container-fluid">
            <div class="h2 mb-2">
                {{ zoneRecoInternet.title }}
            </div>
        </div>
        <div class="container-fluid">
            <div class="mt-2">
                <div class="perso-reco row">
                    <div class="col-6 col-md-3 mb-2 mb-md-1">
                        <ob1-cards
                            :with-composite-link="false"
                            class="h-100"
                        >
                            <a
                                :href="zoneRecoInternet.zoneRecoInternetItem1.urlButton"
                                :data-oevent-category="zoneRecoInternet.zoneRecoInternetItem1.tms.tagZone"
                                :data-oevent-action="tagName(zoneRecoInternet.zoneRecoInternetItem1.labelButton)"
                                :data-oevent-label="zoneRecoInternet.zoneRecoInternetItem1.urlButton"
                            >
                                <img
                                    :src="zoneRecoInternet.zoneRecoInternetItem1.image.src"
                                    class="w-100 card-img-top"
                                    :alt="zoneRecoInternet.zoneRecoInternetItem1.image.alt"
                                >
                                <div class="p-0 p-md-1 text-center">
                                    <h3
                                        class="card-title pb-1"
                                        v-html="zoneRecoInternet.zoneRecoInternetItem1.title"
                                    />
                                    <ob1-liens
                                        class="mt-auto mw-100 d-none d-xl-block"
                                        :text=" zoneRecoInternet.zoneRecoInternetItem1.labelButton"
                                        :href="zoneRecoInternet.zoneRecoInternetItem1.urlButton"
                                        :with-arrow="true"
                                        :data-oevent-category="zoneRecoInternet.zoneRecoInternetItem1.tms.tagZone"
                                        :data-oevent-action="tagName(zoneRecoInternet.zoneRecoInternetItem1.labelButton)"
                                        :data-oevent-label="zoneRecoInternet.zoneRecoInternetItem1.urlButton"
                                    />
                                </div>
                            </a>
                        </ob1-cards>
                    </div>
                    <div class="col-6 col-md-3 mb-2 mb-md-1">
                        <ob1-cards
                            :with-composite-link="false"
                            class="h-100"
                        >
                            <a
                                :href="zoneRecoInternet.zoneRecoInternetItem2.urlButton"
                                :data-oevent-category="zoneRecoInternet.zoneRecoInternetItem2.tms.tagZone"
                                :data-oevent-action="tagName(zoneRecoInternet.zoneRecoInternetItem2.labelButton)"
                                :data-oevent-label="zoneRecoInternet.zoneRecoInternetItem2.urlButton"
                            >
                                <img
                                    :src="zoneRecoInternet.zoneRecoInternetItem2.image.src"
                                    class="w-100 card-img-top"
                                    :alt="zoneRecoInternet.zoneRecoInternetItem2.image.alt"
                                >
                                <div class="p-0 p-md-1 text-center">
                                    <h3
                                        class="card-title pb-1"
                                        v-html="zoneRecoInternet.zoneRecoInternetItem2.title"
                                    />
                                    <ob1-liens
                                        class="mt-auto mw-100 d-none d-xl-block"
                                        :text=" zoneRecoInternet.zoneRecoInternetItem2.labelButton"
                                        :href="zoneRecoInternet.zoneRecoInternetItem2.urlButton"
                                        :with-arrow="true"
                                        :data-oevent-category="zoneRecoInternet.zoneRecoInternetItem2.tms.tagZone"
                                        :data-oevent-action="tagName(zoneRecoInternet.zoneRecoInternetItem2.labelButton)"
                                        :data-oevent-label="zoneRecoInternet.zoneRecoInternetItem2.urlButton"
                                    />
                                </div>
                            </a>
                        </ob1-cards>
                    </div>
                    <div class="col-12 col-md-6 mb-0 mb-md-1">
                        <a
                            class="banner d-flex flex-column justify-content-center ps-1 ps-md-2 h-100"
                            :href="zoneRecoInternet.zoneRecoInternetItem3.url"
                            :data-oevent-category="zoneRecoInternet.zoneRecoInternetItem3.tms.tagZone"
                            :data-oevent-action="zoneRecoInternet.zoneRecoInternetItem3.tms.tagName"
                            :data-oevent-label="zoneRecoInternet.zoneRecoInternetItem3.url"
                        >
                            <ob1-tag
                                :label="zoneRecoInternet.zoneRecoInternetItem3.tag"
                                type="inverse"
                                class="ob1-tag-subscribed badge bg-white ps-2"
                            />
                            <span class="title text-white fw-bold m-0" v-html="zoneRecoInternet.zoneRecoInternetItem3.title" />
                            <img
                                :src="zoneRecoInternet.zoneRecoInternetItem3.image.src"
                                class="banner-img h-100 w-100"
                                :alt="zoneRecoInternet.zoneRecoInternetItem3.image.alt"
                            >
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        zoneRecoInternet: {
            type: Object,
            required: true
        },
    },
    methods: {
        tagName(name) {
            return stripAccents(name).split(' ').join('-')
        },
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_colors';
@import 'ob1_variables';

.perso-reco .card-title {
    font-size: 1rem;
    font-weight: 400;
    margin: 0;
}

@media(min-width: #{map-get($grid-breakpoints, md)}){
    .perso-reco .card-title {
        font-size: 1.25rem;
    }
}

@media(min-width: #{map-get($grid-breakpoints, xl)}) {
    .perso-reco .card-title {
        font-size: 1.625rem;
    }
}

.perso-reco .banner {
    position: relative;
    aspect-ratio: 320/213;
}

@media(min-width: #{map-get($grid-breakpoints, md)}) {
    .perso-reco .banner {
        aspect-ratio: unset;
        padding-left: 30px;
    }
}

.perso-reco .banner .banner-img {
    object-fit: cover;
    object-position: right top;
    position: absolute;
    left: 0;
    top: 0;
}

.perso-reco .banner .title {
    width: 38%;
    position: relative;
    z-index: 2;
    font-size: 1rem;
}

@media(min-width: #{map-get($grid-breakpoints, md)}) {
    .perso-reco .banner .title {
        font-size: 1.0625rem;
    }
}

@media(min-width: #{map-get($grid-breakpoints, xl)}) {
    .perso-reco .banner .title {
        font-size: 1.625rem;
    }
}

.perso-reco .badge {
    position: absolute;
    z-index: 2;
    top: -.07rem;
    left: -.04rem;
}

.ob1-tag.ob1-tag-subscribed::before {
    content: "󬨐";
    font-size: 1rem;
    top: .05rem;
    left: .5rem;
}

</style>
